module.exports = __webpack_public_path__ + "7cf8ecab69dd2b035f6fcaebc50ede4b.svg";